import React from "react";

export const Note = ({ fill, size = 20 }) => {
  return (
    <svg
      height={size}
      width={size}
      viewBox="0 0 12 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Icons"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Rounded" transform="translate(-786.000000, -2859.000000)">
          <g id="Image" transform="translate(100.000000, 2626.000000)">
            <g
              id="-Round-/-Image-/-music_note"
              transform="translate(680.000000, 230.000000)"
            >
              <g>
                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                <path
                  d="M12,5 L12,13.55 C11.06,13.01 9.9,12.8 8.67,13.23 C7.33,13.71 6.3,14.9 6.06,16.3 C5.6,19.04 7.92,21.38 10.65,20.95 C12.61,20.64 14,18.84 14,16.85 L14,7 L16,7 C17.1,7 18,6.1 18,5 C18,3.9 17.1,3 16,3 L14,3 C12.9,3 12,3.9 12,5 Z"
                  id="🔹-Icon-Color"
                  fill={fill}
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
